/* eslint-disable */
export default {
  hide: 'Masquer',
  end: 'Fin',
  keypad: 'Clavier',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
